/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {html} from 'htm/preact';
import {Component} from 'preact';
import PropTypes from 'prop-types';

/*:: type Props<T> = {
  +promise: Promise<T>,
  +initial?: Error | T | null,
  +children?: ?React$Element<*>,
  +then?: (value: T) => React$Element<*> | null,
  +catch?: (error: Error) => React$Element<*> | null,
}; */

export class Async /*:: <T> */ extends Component /*:: <Props<T>, {value: ?T, error: ?Error}> */ {
  static propTypes = {
    promise: PropTypes.instanceOf(Promise).isRequired,
    initial: PropTypes.oneOfType([
      PropTypes.instanceOf(Error),
      PropTypes.object,
    ]),
    children: PropTypes.element,
    then    : PropTypes.func,
    catch   : PropTypes.func,
  };

  abortController /*: ?AbortController */ = null;
  promise /*: ?Promise<T> */ = null;

  constructor(props /*: Props<T> */) {
    super(props);

    const {initial} = props;
    if (initial instanceof Error) {
      this.state = {
        value: null,
        error: initial,
      };
    } else {
      this.state = {
        value: initial,
        error: null,
      };
    }
  }

  componentWillMount() {
    this.setPromise(this.props.promise);
  }
  componentWillReceiveProps(nextProps /*: Props<T> */) {
    this.cancel();
    this.setPromise(nextProps.promise);
  }
  componentWillUnmount() {
    this.cancel();
  }

  setPromise(promise /*: Promise<T> */) {
    this.abortController = new AbortController();
    this.promise = promise;

    this.promise.then(
      (value) => {
        this.setState({value});
      },
      (error) => {
        if (error?.name !== 'AbortError') {
          this.setState({error});
        }
      }
    );
  }
  cancel() {
    this.abortController?.abort();
  }

  render() /*: React$Node */ {
    const {then, catch: katch} = this.props;
    const {value, error} = this.state;

    if (value) {
      return then ? then(value) : null;
    }
    if (error) {
      return katch ? katch(error) : null;
    }
    return html`${this.props.children}`;
  }
}
